import React, { useEffect, useState } from 'react';
import { NavLink } from 'react-router-dom';
import CsLineIcons from 'cs-line-icons/CsLineIcons';
import { Row, Col, Button, Modal } from 'react-bootstrap';
// API
import { getZipCode } from '../../../../api/Api-user';

const ModalAddress = ({ addressDetail, isModalOpen, setIsModalDeleteOpen, handleClose }) => {
  const [city, setCity] = useState({ name: '', state: '' });
  const [addressType, setAddressType] = useState('');

  const fullAddress = `${addressDetail.street} ${addressDetail.street_number}, ${addressDetail.neighborhood}, ${addressDetail.zip_code}.`;
  // useEffect Set Address Type

  useEffect(() => {
    if (addressDetail.address_type === 'RECEIVE') {
      setAddressType('DESTINO');
    } else {
      setAddressType('ORIGEN');
    }
  }, []);

  // Get Initial Letters Start
  let initialLetters = '';
  const words = addressDetail.name.split(' ');
  words.forEach((word) => {
    initialLetters += word.charAt(0); // Obtener la primera letra de cada palabra y agregarla a las iniciales
  });
  // Get Initial Letters End
  // Delete address

  // Get city and state
  useEffect(() => {
    const handlerGetCity = () => {
      getZipCode(addressDetail.zip_code).then((response) => {
        // console.log(response);
        if (response.length > 0) {
          setCity({ name: response[0].city, state: response[0].state.name });
        }
      });
    };
    handlerGetCity();
  }, []);
  // console.log('detalle de domicilio:', addressDetail);
  return (
    <Modal className="modal-right large" show={isModalOpen} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title as="h5">Detalle</Modal.Title>
      </Modal.Header>
      <Modal.Body className="px-3">
        {/* <ModalAddress addressDetail={address} setIsModalOpen={setIsModalOpen} setIsModalDeleteOpen={setIsModalDeleteOpen} /> */}
        <>
          <div className="d-flex align-items-center mx-4 flex-column bg-infox">
            <div className="my-5 d-flex align-items-center flex-column">
              <div className="sw-6 sh-6 mb-2 d-inline-block bg-primary d-flex justify-content-center align-items-center rounded-xl">
                <div className="text-white font-weight-bold">{initialLetters.substring(0, 2).toUpperCase()}</div>
              </div>
              {/* <div className="h5 text-center">{addressDetail.name.toUpperCase()}</div> */}
              {city.name && (
                <div className="text-muted text-center">
                  <span className="align-middle">{`${city.name}, ${city.state}.`}</span>
                </div>
              )}
            </div>
          </div>

          <div className="d-flex flex-column mx-5 bg-alternatex">
            <p className="text-medium text-muted mb-2 mt-3 ps-4">{`DIRECCIÓN DE ${addressType}`}</p>

            <Row className="g-0 mb-2">
              <Col xs="auto">
                <div className="sw-3 me-1">
                  <CsLineIcons icon="user" size="17" className="text-primary" />
                </div>
              </Col>
              <Col className="text-alternate">{addressDetail.name.toUpperCase()}</Col>
            </Row>
            {addressDetail.company && (
              <Row className="g-0 mb-2">
                <Col xs="auto">
                  <div className="sw-3 me-1">
                    <CsLineIcons icon="building" size="17" className="text-primary" />
                  </div>
                </Col>
                <Col className="text-alternate">{addressDetail.company}</Col>
              </Row>
            )}

            <Row className="g-0 mb-2">
              <Col xs="auto">
                <div className="sw-3 me-1">
                  <CsLineIcons icon="pin" size="17" className="text-primary" />
                </div>
              </Col>
              <Col className="text-alternate">{fullAddress}</Col>
            </Row>
            <Row className="g-0 mb-2">
              <Col xs="auto">
                <div className="sw-3 me-1">
                  <CsLineIcons icon="phone" size="17" className="text-primary" />
                </div>
              </Col>
              <Col className="text-alternate">{addressDetail.phone}</Col>
            </Row>
            {addressDetail.reference && (
              <Row className="g-0 mb-2">
                <Col xs="auto">
                  <div className="sw-3 me-1">
                    <CsLineIcons icon="destination" size="17" className="text-primary" />
                  </div>
                </Col>
                <Col className="text-alternate pt-1">{addressDetail.reference}</Col>
              </Row>
            )}
          </div>
        </>
      </Modal.Body>
      <Modal.Footer>
        <div className="d-flex justify-content-end w-100">
          <Button
            className="me-2"
            variant="outline-primary"
            onClick={() => {
              setIsModalDeleteOpen(true);
            }}
          >
            Eliminar
          </Button>

          <NavLink to={`/configuración/direcciones/editar/${addressDetail.id}`}>
            <Button className="me-2">Editar</Button>
          </NavLink>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default ModalAddress;
